/*
 * @Author: hongye
 * @Description:国际化
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import langs from './langs'
import store from '@/store'
import * as constants from '@public/utils/const'

Vue.use(VueI18n)
const lang = constants.LANG_ELEMENT_MAP[store.state.base.lang]

const i18n = new VueI18n({
  locale: lang || process.env.VUE_APP_I18N_LOCALE || 'EN', // 初始未选择默认 en 英文
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'EN',
  messages: { ...langs }
})

export default i18n
